import _toConsumableArray from "/Users/zhaoxu/Documents/development.localized/public.localized/github/KilaKila-Blog/kilakila-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import { reactive, ref } from "vue";
import { getPostArticleList } from "../api/article";
import { defaultThumbnail } from "../utils/thumbnail";
export default {
  name: "Home",
  setup: function setup() {
    var pageSize = 10;
    var postArticles = reactive([]);
    var articleCount = ref(0);
    onCurrentPageChanged(1);

    function onCurrentPageChanged(pageNum) {
      getPostArticleList(pageNum, pageSize).then(function (data) {
        articleCount.value = parseInt(data.total);
        data.rows.forEach(function (article) {
          article.createTime = article.createTime.split(" ")[0];
          article.thumbnail = article.thumbnail || defaultThumbnail;
        }); // 重置列表内容

        postArticles.splice.apply(postArticles, [0, postArticles.length].concat(_toConsumableArray(data.rows)));
      });
    }

    return {
      postArticles: postArticles,
      articleCount: articleCount,
      pageSize: pageSize,
      onCurrentPageChanged: onCurrentPageChanged
    };
  }
};